import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppProviders from './contexts';
import Header from './components/Header';
import AppContent from './pages/AppContent';

const App = () => {
  return (
    <Router>
      <AppProviders>
        <Header />
        <ToastContainer />
        <AppContent />
      </AppProviders>
    </Router>
  );
}

export default App;
